import type { AgentSession } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteSessionDialogProps {
  session: AgentSession | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteSessionDialog({
  session,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteSessionDialogProps) {
  return (
    <Modal open={session !== null} title="Delete session" onClose={onCancel}>
      <p>
        Delete <strong>{session?.label}</strong>? This removes the session record permanently. This
        can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Deleting…" : "Delete"}
        </Button>
      </div>
    </Modal>
  );
}
